import { isAddress } from "../../utils/getContract";
import * as yup from "yup";

export const TokenSubmissionSchema = yup.object().shape({
  tokenAddress: yup
    .string()
    .required("Token address is required")
    .test("isAddress", "Token address is not valid", (value) =>
      isAddress(value)
    ),
  toBlock: yup
    .number()
    .typeError("To block is required")
    .required("To block is required"),
});
